/* Route-aware request state shared by both applications. */
export function installDataLoading(Vue, router, axios) {
  const surfaces = new Set();
  let epoch=0, pending=0, initial=true, failed=false, timer;
  const update=()=>surfaces.forEach(paint);
  function paint(el) {
    const active=initial || pending>0;
    el.classList.toggle('xp-load-initial',initial);
    el.classList.toggle('xp-load-busy',active);
    el.classList.toggle('xp-load-failed',initial&&failed&&pending===0);
    el.setAttribute('aria-busy',active&&!failed?'true':'false');
    if(el._xpLoadingStatus)el._xpLoadingStatus.textContent=failed&&pending===0?'加载失败，请重试':'正在加载页面数据';
  }
  function settle() {
    clearTimeout(timer);
    if(pending===0)timer=setTimeout(()=>{if(!failed)initial=false;update();},120);
  }
  router.beforeEach((to,from,next)=>{epoch++;pending=0;initial=true;failed=false;clearTimeout(timer);update();next();});
  router.afterEach(()=>settle());
  axios.interceptors.request.use(config=>{
    config._xpLoadEpoch=epoch;pending++;clearTimeout(timer);update();return config;
  });
  function end(config,error) {
    if(!config || config._xpLoadEpoch!==epoch)return;
    pending=Math.max(0,pending-1);
    if(error&&initial)failed=true;
    update();settle();
  }
  axios.interceptors.response.use(response=>{end(response.config,false);return response;},error=>{end(error.config,!axios.isCancel(error));return Promise.reject(error);});
  Vue.directive('xp-data-loading',{
    inserted(el) {
      el.classList.add('xp-load-surface');
      const overlay=document.createElement('div');overlay.className='xp-load-overlay';
      overlay.innerHTML='<div class="xp-load-status" role="status" aria-live="polite">正在加载页面数据</div><div class="xp-skeleton-layout" aria-hidden="true"><div class="xp-skeleton-toolbar"><i></i><i></i><i></i></div><div class="xp-skeleton-cards"><i></i><i></i><i></i></div><div class="xp-skeleton-table"><i></i><i></i><i></i><i></i><i></i></div></div><div class="xp-load-retry"><span>数据暂时无法加载，请检查网络后重试。</span><button type="button">重新加载</button></div>';
      overlay.querySelector('button').addEventListener('click',()=>window.location.reload());
      el._xpLoadingStatus=overlay.querySelector('.xp-load-status');el._xpLoadingOverlay=overlay;el.appendChild(overlay);
      const progress=document.createElement('div');progress.className='xp-load-progress';progress.setAttribute('aria-hidden','true');el.appendChild(progress);el._xpLoadingProgress=progress;
      surfaces.add(el);paint(el);settle();
    },
    unbind(el) {surfaces.delete(el);if(el._xpLoadingOverlay)el._xpLoadingOverlay.remove();if(el._xpLoadingProgress)el._xpLoadingProgress.remove();},
  });
}
